import React from 'react';
import { Link } from 'react-router-dom';
import { WORTH_KNOWING } from '../../data/vocabulary';
import { ListenButton, SaveButton } from '../WordActions';
import Reveal from '../Reveal';

const WordsWorthKnowing = () => (
  <section aria-labelledby="worth-heading" className="wrap pb-16 md:pb-24">
    <Reveal className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 id="worth-heading" className="font-display text-4xl leading-tight text-ink md:text-5xl">
          Words worth knowing
        </h2>
        <p className="mt-3 max-w-xl text-lg text-ink-soft">
          A short list of useful words. Hear them, save them, or open the full entry.
        </p>
      </div>
      <Link
        to="/dictionary"
        className="inline-flex h-11 items-center rounded-full border border-ink/20 px-5 font-semibold text-ink transition-[border-color,background-color] hover:border-ink hover:bg-surface"
      >
        Explore more words
      </Link>
    </Reveal>

    <Reveal delay={80} as="ul" className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {WORTH_KNOWING.map((item, index) => {
        const isFeature = index === 0;
        return (
          <li
            key={item.word}
            className={`flex flex-col rounded-[1.75rem] border border-ink/[0.07] p-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-28px_rgb(var(--shade)/0.6)] ${item.color} ${
              isFeature ? 'sm:col-span-2 sm:row-span-1 lg:p-8' : ''
            }`}
          >
            <span className="font-serif text-[0.95rem] italic text-ink-soft">{item.partOfSpeech}</span>
            <Link
              to={`/define/${item.word}`}
              className={`mt-1 block break-words font-display text-ink decoration-2 underline-offset-4 hover:underline ${
                isFeature ? 'text-5xl md:text-6xl' : 'text-3xl'
              }`}
            >
              {item.word}
            </Link>
            <p className={`mt-3 leading-snug text-ink ${isFeature ? 'max-w-md text-xl' : 'text-[1.05rem]'}`}>{item.gloss}</p>
            <div className="mt-auto flex items-center gap-2 pt-6">
              <ListenButton word={item.word} />
              <SaveButton word={item.word} compact />
              <Link to={`/define/${item.word}`} className="ml-auto text-[0.95rem] text-link">
                Full definition
              </Link>
            </div>
          </li>
        );
      })}
    </Reveal>
  </section>
);

export default WordsWorthKnowing;
